import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Job, JobPauseType, PauseJobRequest } from "@/types";

export function useCreateJobPauseRequest() {
  const mutation = useMutation({
    // Resolves with the job, not the request row, so the caller can write
    // pendingPauseRequest straight into its cache.
    mutationFn: async (variables: {
      jobId: string;
      pauseReason: string;
      pauseType: JobPauseType;
    }) => {
      const res = await guacHttpClient.post<
        Job,
        HttpResponse<Job>,
        PauseJobRequest
      >(`jobs/${variables.jobId}/pause-request`, {
        pauseReason: variables.pauseReason,
        pauseType: variables.pauseType,
      });

      return res.data;
    },
  });

  return mutation;
}
